import React from 'react';
import loading from '../helpers/lottie-files/loading.json';
import LottieAnimation from '../components/LottieAnimation';

export default function Loading() {
    return (
        <div className='relative pt-[43px] outer-bg pb-[50px] lg:m-auto lg:w-1/2'>
            <div className={`rounded-t-2xl bg-[#F2F2F2] mx-[8px]`}>
                <div className="h-full px-8">
                    <div className="text-center flex flex-col justify-center items-center h-screen">
                        <div className="loading-bar-container">
                            <div className="loading-bar"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}